/** Returns an object separated by a max value
 *  @param  {array}
 *  @param  {int}
 *  @return  {object}
 */
const getVisibleSections = function (sections, max) {
  return {
    visible: sections.slice(0, max),
    more: sections.slice(max)
  }
}
export { getVisibleSections }
